export const typeDefs = `
  extend type Query {
    isLoggedIn: Boolean!
  }

  extend type Mutation {
    toggleSiteMap: Boolean!
  }
`;
